<template>
  <div class="poll">
    <Poll
      v-if="pollData"
      type="single"
      :open="open"
      :gate="gate"
      :poll="pollData"
      :custom="custom"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Poll from "@/components/poll/Poll.vue";
import firebase from "firebase/app";
import moment from "moment";
export default {
  name: "poll",
  components: {
    Poll
  },
  data() {
    return {
      open: true,
      group: null,
      gate: false,
      pollID: null,
      pollData: [],
      total: null,
      custom: {
        logo: require("@/assets/img/LogoPPmedium.png"),
        obgcolor: "#0066ff",
        otcolor: "#ffffff",
        ebgcolor: "#3c3c3b",
        etcolor: "#ffffff"
      }
    };
  },
  watch: {
    //'$route' : 'fetchData'
  },
  mounted() {
    this.getId();
    this.fetchData();
    this.updateViews();
  },
  methods: {
    currentDate() {
      var today = moment().format("YYYY-MM-DD:HH:mm");
      return today;
    },
    dateKeeper(start, end) {
      //console.log(start, end, this.currentDate());
      //Update Data
      if (this.currentDate() < start) {
        this.open = false;
      }
      if (end < this.currentDate()) {
        this.open = false;
      }
    },
    gateKeeperCookie(id) {
      //var result = false;
      //Update Data
      if (this.$cookies.get("vote" + id)) {
        this.gate = false;
      }
      if (id == this.$cookies.get("vote" + id).poll) {
        this.gate = true;
      }
    },
    getId() {
      return (this.pollID = this.$route.params.id);
    },
    updateViews() {
      var vm = this;
      var id = vm.$route.params.id;
      var firestore = firebase.firestore();
      var docRef = firestore.collection("polls").doc(String(id));
      docRef
        .update({
          views: firebase.firestore.FieldValue.increment(1)
        })
        .then(function() {
          console.log("Document successfully updated view!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    fetchData() {
      var vm = this;
      var id = vm.pollID;
      var firestore = firebase.firestore();
      firestore
        .collection("polls")
        .doc(String(id))
        .onSnapshot(
          function(doc) {
            this.pollData = doc.data();
            this.pollID = doc.id;
            if (doc.data().custom) {
              this.custom = doc.data().custom;
            }
            this.total = doc.data().total;
            //Display Decider
            var startTime = doc.data().startDate + ":" + doc.data().startTime;
            var endTime = doc.data().endDate + ":" + doc.data().endTime;
            vm.dateKeeper(startTime, endTime);
            vm.gateKeeperCookie(doc.id);
          }.bind(vm)
        );
    }
  }
};
</script>
